var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"px-0"},[_c('v-row',[_c('v-col',{attrs:{"cols":"3"}},[_c('Tree')],1),_c('v-col',{attrs:{"cols":"9"}},[_c('v-row',[_c('v-col',{attrs:{"cols":"6"}},[_c('Info')],1),_c('v-col',{attrs:{"cols":"6"}},[_c('Map')],1)],1),_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('Alerts')],1)],1)],1)],1),_c('SecondaryMenu')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }